<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<app-companies-nav [activeMenuItem]="'products'"></app-companies-nav>

<mat-card class="content-card">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex>
      <div style="font-weight: bold; text-align: left" *ngIf="!isLoading">
        SUM ACTIVE CARDS: {{ sumActiveCards | number: '1.0-0' }}
      </div>
    </div>
    <a mat-raised-button color="primary" routerLink="add" *ngIf="deleteEnabled()">Add product</a>
  </mat-card-header>



  <app-mat-table-generator #table
    tableName = "productTable"
    [columns] ="columns"
    [dataSource] ="dataSource"
    [viewLink]="getViewLink"
    [editLink]="getEditLink"
    [editEnabled]="deleteEnabled()"
    [deleteEnabled]="deleteEnabled()"
    [multiselectEnabled]="deleteEnabled()"
    [customActions]="productCustomActions"
    [saveFilters]="true"
    >
</app-mat-table-generator>
</mat-card>
